module.exports = __webpack_public_path__ + "img/4804246_m.13521183.jpg";